import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import {
  danger,
  success,
  showLoading,
} from "../../../components/show-notification";

import api from "../../../providers/api";

import LoadingPanel from "../../../components/loading-painel";

import Layout from "../../../layout";

import validate from "./form-validate";

const ContatoCadastrar = () => {
  const location = useLocation();
  const history = useHistory();

  const [stateSetores, setStateSetores] = useState([]);

  const [state, setState] = useState({
    id: 0,
    setor_id: "",
    nome: "",
    email: "",
    whatsapp: "",
  });

  let preencherValoresEdits = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };

  const enviarFormulario = async (e) => {
    e.preventDefault();

    if (!window.$("#form-contato").valid()) {
      return;
    }

    try {
      const enviar = state.id > 0 ? api.put : api.post;

      const requisicao = await enviar("/contato", state);

      const { data } = requisicao;

      if (!data.status) {
        danger(data.mensagem);
        return;
      }

      if (!data.data) {
        return;
      }

      success(data.mensagem);
      history.push("/contato");
    } catch (error) {
      console.log(error);
      danger("Erro ao cadastrar o contato.");
    }
  };

  const buscarDados = async (url) => {
    const requisicao = await api.get(`${url}`);

    const { data } = requisicao;

    if (!data.status) {
      danger(data.mensagem);
      return;
    }

    if (!data.data) {
      return;
    }

    return data.data;
  };

  const carregarSetores = async () => {
    return await buscarDados("/setor");
  };

  const carregarDados = async () => {
    if (!location.state) {
      return;
    }

    return await buscarDados(`/contato/${location.state.id}`);
  };

  useEffect(() => {
    const carregarTodosDados = async () => {
      try {
        showLoading(".ibox-content");

        const [setores, contato] = await Promise.all([
          carregarSetores(),
          carregarDados(),
        ]);

        setStateSetores(setores);

        if (contato) {
          setState(contato);
        }

        showLoading(".ibox-content");
      } catch (error) {
        console.log(error);
        showLoading(".ibox-content");
        danger("Erro ao carregar os dados do contato");
      }
    };

    let validacao = window.$("#form-contato").validate(validate);

    carregarTodosDados();

    return () => validacao.destroy();
  }, [location.state]);

  return (
    <>
      <Layout
        titulo="Ibraflex - Contatos"
        header="Cadastro do Contato"
        action={{ titulo: "Voltar", link: "/contato" }}
      >
        <div className="row">
          <div className="col-lg-12">
            <div className="ibox ">
              <div className="ibox-title">
                <h5>Dados do contato</h5>
              </div>
              <div className="ibox-content">
                <LoadingPanel />
                <div className="row">
                  <div className="col-lg-12">
                    <form id="form-contato">
                      <div className="form-group">
                        <div className="row">
                          <div className="col-lg-3">
                            <label>Selecione o setor</label>
                            <select
                              className="form-control"
                              id="setor_id"
                              name="setor_id"
                              value={state.setor_id}
                              onChange={(e) => preencherValoresEdits(e)}
                            >
                              <option key="-1" value="">
                                Selecione um setor
                              </option>

                              {stateSetores.map((setor) => (
                                <option key={setor.id} value={setor.id}>
                                  {setor.nome}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="col-lg-3">
                            <label>Nome do contato</label>
                            <input
                              type="text"
                              placeholder="Nome do contato"
                              className="form-control"
                              name="nome"
                              value={state.nome}
                              onChange={(e) => preencherValoresEdits(e)}
                            />
                          </div>
                          <div className="col-lg-4">
                            <label>Email do contato</label>
                            <input
                              type="text"
                              placeholder="Email do contato"
                              className="form-control"
                              name="email"
                              value={state.email}
                              onChange={(e) => preencherValoresEdits(e)}
                            />
                          </div>
                          <div className="col-lg-2">
                            <label>Whatsapp do contato</label>
                            <input
                              type="text"
                              placeholder="Whatsapp do contato"
                              className="form-control"
                              name="whatsapp"
                              value={state.whatsapp}
                              onChange={(e) => preencherValoresEdits(e)}
                            />
                          </div>
                        </div>
                      </div>
                      <div>
                        <button
                          className="btn btn-sm btn-success float-right m-t-n-xs"
                          type="submit"
                          onClick={(e) => enviarFormulario(e)}
                        >
                          <strong>Salvar</strong>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default ContatoCadastrar;
